<template>
  <div class="tags">
    <breadcrumb :links="breadcrumb" />
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Tags by Creative: {{ tags[0].creative.name }}</span>
      </heading-wrap>
      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Client: <router-link :to="{ path: `/client/${tags[0].creative.campaign.client.hash_id}` }">{{ tags[0].creative.campaign.client.name }}</router-link></h5>
              <h5 class="card-title">Campaign: <router-link :to="{ path: `/campaigns/${tags[0].creative.campaign.hash_id}` }">{{ tags[0].creative.campaign.name }}</router-link></h5>
              <h5 class="card-title">Creative: <router-link :to="{ path: `/creatives/${tags[0].creative.hash_id}/bulk` }">{{ tags[0].creative.name }}</router-link></h5>
            </div>
          </div>
        </div>
      </div>
      <spinner v-if="loading" />
      <hr/>
      <search-box v-model="search" name="tags..." />

      <slot-table v-if="tags" :tableData="filteredTags" :data="filteredTags" :columns="table.columns" >

        <template slot="client" slot-scope="props">
          <span>
            <router-link :to="{ path: `/client/${props.item.creative.campaign.client.hash_id}` }">
              {{ props.item.creative.campaign.client.name }}
            </router-link>
          </span>
        </template>

        <template slot="campaign" slot-scope="props">
          <span>
            <router-link :to="{ path: `/campaigns/${props.item.creative.campaign.hash_id}` }">
              {{ props.item.creative.campaign.name }}
            </router-link>
          </span>
        </template>

        <template slot="creative" slot-scope="props">
          <span>
            <router-link :to="{ path: `/creatives/${props.item.creative.hash_id}/bulk` }">
              {{ props.item.creative.name }}
            </router-link>
          </span>
        </template>

        <template slot="status" slot-scope="props">
          <progress-bar :value="props.item.ad_tag_count_completed / props.item.ad_tag_count * 100" :status="props.item.status" />
        </template>

        <template slot="ad_tag_count" slot-scope="props">
          <span>{{ props.item.ad_tag_count_completed }} / {{ props.item.ad_tag_count }} </span>
        </template>

        <template slot="date" slot-scope="props">
          <span>{{ props.item.date_created.value | formatDate }} </span>
        </template>

        <template slot="tagActions" slot-scope="props">
          <a class="btn btn-primary btn-xs" :href="tagUrl(props.item.hash_id)" title="Tag Overview"><i class="fa fa-tag" aria-hidden="true"></i></a>
          <button-cta title="Refresh creative on Preview tag" class="btn btn-info btn-xs" data-modalType="refreshTag" :data-modalID="props.item.hash_id" :onClick="onLaunchModal">
            <i class="fa fa-retweet" aria-hidden="true"></i>
          </button-cta>
          <button-cta title="Edit Preview tag name" data-modalType="editTag" :data-modalField="props.item.name" :data-modalID="props.item.hash_id" :onClick="onLaunchModal"
                      class="btn btn-warning btn-xs">
            <i class="fa fa-pencil" aria-hidden="true"></i>
          </button-cta>
          <button-cta title="Delete Preview Tag" data-modalType="deleteTag" :data-modalID="props.item.hash_id" :onClick="onLaunchModal"
                      class="btn btn-danger btn-xs">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button-cta>
        </template>

      </slot-table>
    </div>
    <portal to="globalModal">
      <modal-tag-confirm :show="showModal.deleteTag" :type="modalType" :confirmId="modalId" @close="toggleModal('deleteTag')"/>
      <modal-edit-tag :show="showModal.editTag" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('editTag')"/>
      <modal-refresh-tag :updateStatus="updateStatus" :show="showModal.refreshTag" :type="modalType" :confirmId="modalId" @close="toggleModal('refreshTag')"/>
    </portal>

  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import Breadcrumb from '@/components/Breadcrumb/breadcrumb'
import ButtonCta from '@/components/Button/button'
import Modal from '@/components/Modal/modal'
import ShareUrlBox from '@/components/ShareUrlBox/share-url-box'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import ProgressBar from '@/components/ProgressBar/progress-bar'
import ModalTagConfirm from '@/components/Modal/tags/modal-tag-confirm'
import ModalEditTag from '@/components/Modal/tags/modal-edit-tag'
import ModalRefreshTag from '@/components/Modal/tags/modal-refresh-tag'
import {modalMixin} from '@/mixins/modalMixin'
import {tagMixin} from '@/mixins/tagMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

// import { url } from '@/config'

import { assoc, map } from 'ramda'

export default {
  name: 'Tags',
  mixins: [modalMixin, tagMixin, notificationMixin],
  components: {
    HeadingWrap,
    Breadcrumb,
    ShareUrlBox,
    ButtonCta,
    Modal,
    SlotTable,
    Spinner,
    SearchBox,
    ProgressBar,
    ModalTagConfirm,
    ModalEditTag,
    ModalRefreshTag
  },
  props: {
    tableData: Array
  },
  data: () => ({
    search: '',
    table: {
      columns: {
        name: 'Name',
        date: 'Date Created',
        client: 'Client',
        status: 'Status',
        ad_tag_count: 'Creatives',
        campaign: 'Campaign Name',
        creative: 'Creative Name',
        tagActions: ''
      }
    }
  }),
  mounted () {
    this.getAllTagsCreative(this.$route.params.id).then((response) => {
      this.tagCollection = response
      this.finishLoading()
      this.updateStatus()
    })
  },
  computed: {
    filteredTags () {
      return this.tags.filter(tag => {
        return tag.name.toLowerCase().includes(this.search.toLowerCase()) || tag.creative.name.toLowerCase().includes(this.search.toLowerCase()) || tag.creative.campaign.name.toLowerCase().includes(this.search.toLowerCase()) || tag.creative.campaign.client.name.toLowerCase().includes(this.search.toLowerCase())
      }).reverse()
    },
    formattedTags () {
      return map(item => assoc('tagActions', true, item), this.tags).reverse()
    },
    breadcrumb () {
      if (this.tags[0] && this.tags[0].creative) {
        return [
          {
            name: this.tags[0].creative.campaign.client.name,
            path: `client/${this.tags[0].creative.campaign.client.hash_id}`
          },
          {
            name: this.tags[0].creative.campaign.name,
            path: `campaigns/${this.tags[0].creative.campaign.hash_id}`
          },
          {
            name: this.tags[0].creative.name,
            path: `creatives/${this.tags[0].creative.hash_id}/bulk`
          },
          {
            name: 'Tags by Creative',
            path: '',
            active: true
          }
        ]
      }
    }
  },
  methods: {
    tagUrl (id) {
      return '/tags/detail/' + id
    },
    updateStatus (force) {
      console.log('update status')
      let update = false
      this.tags.forEach((tag) => {
        console.log(tag.status)
        if (tag.status !== 'completed' || force) {
          update = true
        }
      })
      if (update) {
        setTimeout(() => {
          this.getAllTagsCreative(this.$route.params.id).then(() => {
            this.updateStatus()
          })
        }, 3000)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tags/creative.vue